import { Component, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

import { FiatWallet, Provider, User } from "@models";
import { UserService } from "../../services/user.service";
import { FiatWalletService } from "../../services/wallet/fiat_wallet.service";
import { VERIFICATION_MODAL_ROUTE } from "@helpers/constants";
import { FiatService } from "@main-services/currency";
import { ModalService } from "@core-services/modal.service";
import { BpTileComponent } from "../../../core/components/bp-tile/bp-tile.component";
import { MasterdataService } from "@core-services/masterdata.service";
import { take } from "rxjs/operators";
import { VerificationModalFacade } from "@modules/verification/modal/state/verification-modal.facade";

@Component({
	selector: "fiat-wallet-details",
	templateUrl: "./fiat-wallet-details.component.html",
	styleUrls: ["./fiat-wallet-details.component.scss"],
	standalone: false
})
export class FiatWalletDetailsComponent {
	@ViewChild("depositAddressTile", { static: true })
	public depositAddressTile: BpTileComponent;
	public wallet: FiatWallet;
	private defaultProvider: Provider = null;

	public constructor(
		private fiatWalletService: FiatWalletService,
		private route: ActivatedRoute,
		private verificationModalFacade: VerificationModalFacade,
		private router: Router,
		private modalService: ModalService,
		private fiatService: FiatService,
		private masterdataService: MasterdataService,
		private userService: UserService
	) {
		this.route.params.forEach((p) => {
			if (p.hasOwnProperty("pid")) {
				this.fiatWalletService
					.getList()
					.pipe(take(1))
					.subscribe((l) => {
						if (l.length > 0 && l.every((w) => !!w)) {
							this.wallet = this.fiatWalletService.getItemById(p["pid"]);

							this.defaultProvider = this.getDefaultProvider();

							if (!this.wallet) {
								this.router.navigateByUrl("/portfolio");
							}
						}
					});
			}
		});
	}

	public goBackToWallet(): void {
		this.router.navigateByUrl("/fiat-wallet/" + this.wallet.getId());
	}

	public downloadPdf(): void {
		this.fiatWalletService.download(this.wallet, 0, this.defaultProvider.getId(), this.userService.user.getId());
	}

	public get isAtLeastDocumented(): boolean {
		return this.userService.isAtLeastDocumented;
	}

	public get isUnverified(): boolean {
		return this.userService.isUnverified;
	}

	public get user(): User {
		return this.userService.user;
	}

	public startVerify(): void {
		if (!this.verificationModalFacade.openVerification()) {
			this.router.navigate(VERIFICATION_MODAL_ROUTE, {
				skipLocationChange: true
			});
		}
	}

	public showNonEuInfo(): boolean {
		return !this.defaultProvider.isNonSepaBank();
	}

	// Checks for a default payment option of the fiat wallet
	private getDefaultProvider(): Provider {
		return this.masterdataService.getDefaultPaymentByFiat(this.wallet.getCurrencyId());
	}
}
